<div class="dropdown-container" [class.is-active]="dropdownOpen" [attr.aria-expanded]="dropdownOpen" tabindex="0" (keydown.escape)="closeDropdown()">
  <div class="dropdown-display-bar" (click)="onDisplayBarClick($event)" [class.is-open]="dropdownOpen">
    <ng-container *ngIf="(!multiSelect && selectedOption) || (multiSelect && selectedOptions.length > 0); else showPlaceholderContent_unified">
      <span class="selected-text">
        {{ multiSelect ? getSelectedLabels() : selectedOption ? selectedOption[labelKey] : '' }}
      </span>
    </ng-container>
    <ng-template #showPlaceholderContent_unified>
      <span class="ep-text-regular-16 ep-text-tertiary-text placeholder">{{ placeholder }}</span>
    </ng-template>
    <span class="dropdown-arrow-svg"></span>
  </div>

  <div class="dropdown-open-content-area" *ngIf="dropdownOpen">
    <div class="search-area-wrapper">
      <div class="dropdown-search-wrapper">
        <span class="search-icon"></span>
        <input
          #searchInput
          type="text"
          class="ep-text-regular-16 ep-text-secondary-text dropdown-search"
          [placeholder]="getSearchPlaceholder"
          [(ngModel)]="searchTerm"
          (ngModelChange)="searchInput$.next($event)"
          (click)="$event.stopPropagation()"
          autocomplete="off"
        />
      </div>
    </div>

    <div class="options-area-wrapper">
      <div class="dropdown-panel" role="listbox" (click)="onPanelClick($event)">
        <ul class="dropdown-options">
          <li
            *ngFor="let option of filteredOptions"
            (click)="toggleSelection(option); $event.stopPropagation()"
            class="option-item"
            [class.selected]="isSelected(option)"
            [attr.aria-selected]="isSelected(option)"
            role="option"
            tabindex="0"
            (keydown.enter)="onOptionKeydown($event, option)"
            (keydown.space)="onOptionKeydown($event, option)"
          >
            <div class="option-item-content">
              <mat-checkbox
                *ngIf="multiSelect"
                [checked]="isSelected(option)"
                (change)="toggleSelection(option); $event.stopPropagation()"
                [disableRipple]="true"
                class="option-checkbox"
                tabindex="-1"
                (click)="$event.stopPropagation()"
              ></mat-checkbox>
              <span class="ep-text-regular-16 option-label">
                {{ option[labelKey] }}
              </span>
            </div>
          </li>
        </ul>
      </div>
    </div>
  </div>
</div>
